import React, {Component} from 'react';
import StackTeamsExposure from './stack-teams-exposure';
import StackTeams from './stack-teams';
import StackTeamsChecking from './stack-teams-checking';
import TotalMinExposure from './total-min-exposure';
import LineGroupsChecking from './line-groups-checking';
import PPLinesChecking from './pp-lines-checking';

class SingleStackOptions extends Component {
    render() {
        const stackNumber = 1;

        return (
            <div className="team-stack nhl-stack">
                <div className="form-row-new">
                    <div className="form-inline">
                        <strong className="form-text">
                            Team <br className="hide-desktop" /> exposures:
                        </strong>
                        <StackTeamsExposure stackNumber={stackNumber} />
                    </div>
                    <TotalMinExposure stackNumber={stackNumber} />
                </div>
                <div className="chk-all-stack">
                    <div className="checkbox">
                        <StackTeamsChecking stackNumber={stackNumber} />
                    </div>
                </div>
                <div className="stack-container">
                    <StackTeams stackNumber={stackNumber} />
                </div>
                <div className="chk-group-row">
                    <LineGroupsChecking stackNumber={stackNumber} />
                    <PPLinesChecking stackNumber={stackNumber} />
                </div>
            </div>
        );
    }
}

export default SingleStackOptions;
